import React from 'react';

const AboutTeam = () => (
  <div className="row about-people hidden-xs">
    <div className="container" style={{ margin: '0 auto', textAlign: 'center' }}>
      <div className="col-sm-4 col-ms-6">
        <img className="img-responsive row" src="/images/about-team1.jpg" alt="" />
      </div>
      <div className="col-sm-4 col-ms-6">
        <img className="img-responsive row" src="/images/about-team2.jpg" alt="" />
      </div>
      <div className="col-sm-4 col-ms-6">
        <img className="img-responsive row" src="/images/about-team3.jpg" alt="" />
      </div>
    </div>
  </div>
);

export default AboutTeam;
